import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { gangSchemaObject } from '../gangSchema';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { element } from 'prop-types';
import { functions } from 'lodash';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'GANG';

export function GangAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Add Gang")
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [devisions, setDevisions] = useState()
    const [gang, setGang] = useState({
        groupID: "0",
        operationEntityID: "0",
        gangName:'',
        gangCode:'',
        collectionPointID: "0",
        isActive: true
    });
    const [buttonName, setButtonName] = useState("Save");
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    const [pageProperties, setPageProperties] = useState({
        title: 'Add Gang',
        submitButtonName: 'Save'
    })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });


    const schema = Joi.object(gangSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
    }, []);


    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [gang.groupID])

    useEffect(() => {
        trackPromise(
            getDevisions()
        )
    }, [gang.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITGANG');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });


        if (data && edit) {
            setTitle("Edit Gang");
            setGang(data);
            setDevisionForEdit()
            setButtonName("Update");
            
        } else {
            
            setTitle("Add Gang");
            var token = tokenService.getUserDetailsFromToken();
            setGang({
                ...gang,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getAllGroups()
        )
    }

    async function setDevisionForEdit() {
        const result = await services.getDivisions(data.operationEntityID)
        setDevisions(result)
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setGang({
            ...gang,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID:'0'
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);

        setGang({
            ...gang,
            operationEntityID: target.value,
            collectionPointID: '0'
        })
    }

    function handleCollectionPointChange(target) {
        validateInputs(target);

        setGang({
            ...gang,
            collectionPointID: target.value
        })
    }
    function handleGangNameChange(target) {
        validateInputs(target);
        setGang({
            ...gang,
            gangName: target.value
        })
    }
    function handleGangCodeChange(target) {
        validateInputs(target);
        setGang({
            ...gang,
            gangCode: target.value
        })
    }

    function handleActiveChange(target) {
        validateInputs(target);

        setGang({
            ...gang,
            isActive: target.checked
        })
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, gangSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, gang)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return

            if (!edit) {
                const response = await services.saveGang(gang);
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
                afterSuccessfulyChanged(response.statusCode)
            }
            if (edit) {
                const response = await services.editGang(gang);
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
                afterSuccessfulyChanged(response.statusCode)
            }
    }

    function afterSuccessfulyChanged(response) {

        if (response === "Success") {

            setTimeout(() => {
                props.history.push({ pathname: '/gang' })
            }, 1500);
        }
    }

    async function getEstates() {
        const result = await services.getEstatesByGroupID(gang.groupID)
        setEstates(result)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getDevisions() {
        const result = await services.getDivisions(gang.operationEntityID)
        setDevisions(result)
    }
    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function clearButton() {
        setErrors({});
        var token = tokenService.getUserDetailsFromToken();
        setGang({
            ...gang,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            collectionPointID: 0,
            gangName:'',
            gangCode:'',
            isActive: true
        });
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/gang"

                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)}>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={gang.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={gang.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="collectionPointID">Devision *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={gang.collectionPointID}
                                            onChange={(e) => handleCollectionPointChange(e.target)}>
                                            <MenuItem value="0">--Select Devision--</MenuItem>
                                            {generateDropDownMenu(devisions)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                
                                <div className="form-group row">
                                {/* <div className="col-md pb-1">
                                        <InputLabel shrink id="fieldID">Field *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="fieldID"
                                            name="fieldID"
                                            value={gang.fieldID}
                                            onChange={(e) => handleFieldhange(e.target)}>
                                            <MenuItem value="0">--Select Field--</MenuItem>
                                            {generateDropDownMenu(fields)}
                                        </Select>
                                        {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                    </div> */}
                                    <div className="col-md">
                                        <InputLabel shrink id="gangCode">Gang Code *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="gangCode"
                                            id="gangCode"
                                            onChange={(e) => handleGangCodeChange(e.target)}
                                            value={gang.gangCode}
                                        />
                                        {errors["gangCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["gangCode"]}</FormHelperText>}

                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="gangName">Gang Name *</InputLabel>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            name="gangName"
                                            id="gangName"
                                            onChange={(e) => handleGangNameChange(e.target)}
                                            value={gang.gangName}
                                        />
                                        {errors["gangName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["gangName"]}</FormHelperText>}

                                    </div>
                                    
                                </div>

                                <label htmlFor="switch1" >Active</label>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="isActive"
                                            switch="none"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleActiveChange(e.target)}
                                            checked={gang.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>
                                <MessageModal
                                    hidden={messageModel.hidden}
                                    messageType={messageModel.type}
                                    messageDescription={messageModel.disciption}
                                    clicked={modalDismissHandler}
                                />

                                <div className="card-footer">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                        onClick={handleSave}
                                    />
                                    <input
                                        type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={clearButton}
                                    />
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}